import { type FC, useContext, useMemo } from "react";
import UnescapedContent from "../../../../Misc/UnescapedContent";
import { createStyleFromPadding } from "../../../PaddingInput";
import { createBorderStyles } from "../../BorderSettingsDialog";
import { DragDropRenderContext } from "../../DragDropRenderer";
import type { ComponentOptions } from "../../DragDropTypes";

export const TextComponent: FC<ComponentOptions> = ({
    style: styleProps,
    value,
}) => {
    const { textReplacement } = useContext(DragDropRenderContext);

    const text = useMemo(() => {
        if(typeof value !== "string") {
            return "";
        }

        return textReplacement.parse(value);
    }, [ value, textReplacement ]);

    const isEmpty = useMemo(() => {
        if(!text) {
            return true;
        }

        const parser = new DOMParser();
        const doc = parser.parseFromString(text, "text/html");

        return !doc.body.textContent.trim();
    }, [ text ]);

    if(isEmpty) {
        return null;
    }

    const {
        padding,
        border,
        fontSize,
        ...styleRest
    } = styleProps;

    const style = {
        width   : "100%",
        ...styleRest,
        fontSize: typeof fontSize === "undefined" ? fontSize : `${fontSize}px`,
        ...(typeof padding !== "undefined" ? createStyleFromPadding(padding) : {}),
        ...(typeof border !== "undefined" ? createBorderStyles(border) : {}),
        overflow: "hidden",
    };

    return (
        <UnescapedContent style={style}>
            {text}
        </UnescapedContent>
    );
};
